import { IScheduleActivityCostCodeCostType } from '../../interfaces/ischedule-activity-cost-code-cost-type';
import { CostCodeCostTypeProjectCombination } from '../cost-code-cost-type-project-combination';
import { ResourceCostCodeCostType } from '../resource-cost-code-cost-type';
import { ScheduleActivity } from '../schedule-activity';

export class ScheduleActivityCostCodeCostTypeBase {
  ScheduleActivityCostCodeCostTypeId: number;
  ResourceCostCodeCostTypeId: number | null;
  ScheduleActivityId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  CostCodeCostTypeProjectCombinationId: number | null;

  CostCodeCostTypeProjectCombination?: CostCodeCostTypeProjectCombination;
  ResourceCostCodeCostType?: ResourceCostCodeCostType;
  ScheduleActivity?: ScheduleActivity;

  constructor(item?: IScheduleActivityCostCodeCostType) {
    if (item) {

      this.ScheduleActivityCostCodeCostTypeId = item.ScheduleActivityCostCodeCostTypeId;
      this.ResourceCostCodeCostTypeId = item.ResourceCostCodeCostTypeId;
      this.ScheduleActivityId = item.ScheduleActivityId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.CostCodeCostTypeProjectCombinationId = item.CostCodeCostTypeProjectCombinationId;

      this.CostCodeCostTypeProjectCombination = new CostCodeCostTypeProjectCombination(item.CostCodeCostTypeProjectCombination);
      this.ResourceCostCodeCostType = new ResourceCostCodeCostType(item.ResourceCostCodeCostType);
      this.ScheduleActivity = new ScheduleActivity(item.ScheduleActivity);
    }
  }
}